import { render } from "./ViewParentPage.vue?vue&type=template&id=6d74d091&ts=true"
import script from "./ViewParentPage.vue?vue&type=script&lang=ts"
export * from "./ViewParentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__